var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-sidebar-content" },
    [
      _vm.loading
        ? _c("rb-loader-glasses")
        : _c(
            "div",
            {
              staticClass: "rb-sidebar-content__top-section wishlist-container",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "rb-sidebar-content__top-section-title rb-sidebar-content__top-section-title--desktop preventSafariGlitch",
                },
                [
                  _vm.isEmpty
                    ? _c("div", [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.translation(
                                "common.sidebar_miniwishlist_title"
                              )
                            ) +
                            "\n      "
                        ),
                      ])
                    : _c("div", { staticClass: "preventSafariGlitch" }, [
                        _vm._v(
                          _vm._s(_vm.wishListHeader) +
                            " (" +
                            _vm._s(_vm.totalCount) +
                            ")"
                        ),
                      ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "wishlist-close",
                      on: { keypress: _vm.exitWishlist },
                    },
                    [_c("rb-lazy-icon", { attrs: { icon: "delete" } })],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "rb-sidebar-content__top-section-title rb-sidebar-content__top-section-title--desktop",
                },
                [
                  _c("rb-lazy-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: "valid-input" },
                  }),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.translation(
                          "common.sidebar_miniwishlist_added_title"
                        )
                      ) +
                      "\n    "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isMobile
                ? _vm._l(_vm.getMiniwishlistItemMobile, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.catentryId,
                        staticClass: "rb-sidebar-content__item",
                      },
                      [
                        _c("div", { staticClass: "grid grid--gap-2" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-5 rb-sidebar-content__item-left-column",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "rb-sidebar-content__wishlist-item-img-wrapper",
                                  attrs: {
                                    href: item.pdpURL,
                                    "data-element-id":
                                      "X_X_MainNav_Account_Tiles",
                                    "data-description": _vm.getDataDescription(
                                      item.name,
                                      item.partnumber
                                    ),
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.imgGreyBackground(item.image),
                                      alt: item.displaySKU,
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-7 rb-sidebar-content__item-right-column",
                            },
                            [
                              item.isRemix
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "rb-sidebar-content__title rb-sidebar-content__title--labeled",
                                    },
                                    [
                                      _c("rb-lazy-icon", {
                                        attrs: { icon: "remix" },
                                      }),
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.name) +
                                          "\n              "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "rb-sidebar-content__label",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.translation(
                                                  "common.sidebar_remixed"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "rb-sidebar-content__title",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.name) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                              _vm._v(" "),
                              !_vm.isGiftCard(item.category)
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "rb-sidebar-content__modelname",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.modelName) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isProductStella(item.category)
                                ? _c(
                                    "span",
                                    { staticClass: "wcs-product--electronics" },
                                    [
                                      _c("rb-lazy-icon", {
                                        attrs: { icon: "electronics" },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "category-name" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translation(
                                                "pdp.category_name"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.isPrescription && !item.isRemix
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "rb-sidebar-content__info--rox",
                                    },
                                    [
                                      _vm._v(
                                        "\n              Prescription\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.isPrescription && item.isRemix
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "rb-sidebar-content__info--rox-remix",
                                    },
                                    [
                                      _c("rb-lazy-icon", {
                                        attrs: { icon: "remix" },
                                      }),
                                      _vm._v(
                                        "\n              Prescription\n            "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "rb-sidebar-content__info" },
                                [
                                  item.frame && item.frame.value
                                    ? _c("p", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translation(
                                                "common.sidebar_frame"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.frame.value) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.frontColor
                                    ? _c("p", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translation(
                                                "common.sidebar_frame"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.frontColor) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.lenses && item.lenses.value
                                    ? _c("p", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translation(
                                                "common.sidebar_lenses"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.lenses.value) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.lensColor
                                    ? _c("p", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translation(
                                                "common.sidebar_lenses"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.lensColor) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.size
                                    ? _c("p", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translation(
                                                "common.sidebar_size"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              item.size.value
                                                ? item.size.value
                                                : item.size
                                            ) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.includedText
                                    ? _c("p", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translation(
                                                "common.sidebar_included"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.includedText) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              !item.isRemix
                                ? [
                                    item.price &&
                                    item.price.list === item.price.offer
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rb-sidebar-content__price",
                                          },
                                          [
                                            _c("format-price", {
                                              attrs: {
                                                value: Number(
                                                  _vm.getPriceFromItem(item)
                                                ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.price &&
                                    item.price.list !== item.price.offer
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rb-sidebar-content__price",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rb-pdp-sticky-bar__price__original",
                                              },
                                              [
                                                _c("format-price", {
                                                  attrs: {
                                                    value: Number(
                                                      item.price.list
                                                    ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rb-pdp-sticky-bar__price__discounted",
                                              },
                                              [
                                                _c("format-price", {
                                                  attrs: {
                                                    value: Number(
                                                      item.price.offer
                                                    ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : [
                                    item.discountPrice &&
                                    item.discountPrice !== item.price
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rb-sidebar-content__price",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rb-pdp-sticky-bar__price__original",
                                              },
                                              [
                                                _c("format-price", {
                                                  attrs: {
                                                    value: Number(item.price),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rb-pdp-sticky-bar__price__discounted",
                                              },
                                              [
                                                _c("format-price", {
                                                  attrs: {
                                                    value: Number(
                                                      item.discountPrice
                                                    ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rb-sidebar-content__price",
                                          },
                                          [
                                            _c("format-price", {
                                              attrs: {
                                                value: Number(item.price),
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                  ],
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "rb-btn rb-btn--underlined rb-sidebar-content__item-remove",
                                  attrs: {
                                    type: "",
                                    "data-element-id":
                                      "X_X_MainNav_Account_Remove",
                                    "data-description": _vm.getDataDescription(
                                      item.name,
                                      item.partnumber
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeFromWishlist(item)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.translation("common.sidebar_remove")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              item.addToBagFlag
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "rb-btn rb-btn--red rb-sidebar-content__btn",
                                      attrs: {
                                        "data-element-id":
                                          "X_X_MainNav_Account_AddCart",
                                        "data-description":
                                          _vm.getDataDescription(
                                            item.name,
                                            item.partnumber
                                          ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addToBag(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translation(
                                              "common.sidebar_miniwishlist_addto_bag"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ]
                    )
                  })
                : _vm._l(_vm.items, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.catentryId,
                        staticClass: "rb-sidebar-content__item",
                      },
                      [
                        _c("div", { staticClass: "grid grid--gap-2" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 rb-sidebar-content__item-left-column",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "rb-sidebar-content__wishlist-item-img-wrapper",
                                  attrs: { href: item.pdpURL },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.imgGreyBackground(item.image),
                                      alt: item.displaySKU,
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "rb-btn rb-btn--underlined rb-sidebar-content__item-remove",
                                  attrs: {
                                    type: "",
                                    "data-element-id":
                                      "X_X_WishListOverlay_Remove",
                                    "data-description":
                                      item.name + "_" + item.partnumber,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeFromWishlist(item)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.translation("common.sidebar_remove")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-8 rb-sidebar-content__item-right-column",
                            },
                            [
                              item.isRemix
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "rb-sidebar-content__title",
                                      class: {
                                        "rb-sidebar-content__title--labeled":
                                          !item.isPrescription,
                                      },
                                    },
                                    [
                                      !item.isPrescription
                                        ? _c("rb-lazy-icon", {
                                            attrs: { icon: "remix" },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.name) +
                                          "\n              "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "rb-sidebar-content__label",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.translation(
                                                  "common.sidebar_remixed"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "rb-sidebar-content__title",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.name) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                              _vm._v(" "),
                              !_vm.isGiftCard(item.category)
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "rb-sidebar-content__modelname",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.modelName) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isProductStella(item.category)
                                ? _c(
                                    "span",
                                    { staticClass: "wcs-product--electronics" },
                                    [
                                      _c("rb-lazy-icon", {
                                        attrs: { icon: "electronics" },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "category-name" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translation(
                                                "pdp.category_name"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "rb-sidebar-content__info" },
                                [
                                  item.isPrescription && !item.isRemix
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "rb-sidebar-content__info--rox",
                                        },
                                        [
                                          _vm._v(
                                            "\n                Prescription\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.isPrescription && item.isRemix
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "rb-sidebar-content__info--rox-remix",
                                        },
                                        [
                                          _c("rb-lazy-icon", {
                                            attrs: { icon: "remix" },
                                          }),
                                          _vm._v(
                                            "\n                Prescription\n              "
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.frame && item.frame.value
                                    ? _c("p", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translation(
                                                "common.sidebar_frame"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.frame.value) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.frontColor
                                    ? _c("p", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translation(
                                                "common.sidebar_frame"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.frontColor) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.lenses && item.lenses.value
                                    ? _c("p", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translation(
                                                "common.sidebar_lenses"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.lenses.value) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.lensColor
                                    ? _c("p", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translation(
                                                "common.sidebar_lenses"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.lensColor) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.producType === _vm.REMIX &&
                                  item.lenses &&
                                  item.lensType &&
                                  item.prescriptionType
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rb-sidebar-content__info--remix",
                                          },
                                          [
                                            _c("div", { staticClass: "grid" }, [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "rb-sidebar-content__info--remix-title col",
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.lenses.label
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col" },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.lensType) +
                                                      "\n                      " +
                                                      _vm._s(
                                                        item.lenses.value
                                                      ) +
                                                      "\n                      " +
                                                      _vm._s(
                                                        item.prescriptionType
                                                          .prescriptionType
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.size
                                    ? _c("p", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translation(
                                                "common.sidebar_size"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              item.size.value
                                                ? item.size.value
                                                : item.size
                                            ) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.includedText
                                    ? _c("p", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translation(
                                                "common.sidebar_included"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.includedText) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              !item.isRemix
                                ? [
                                    item.price &&
                                    item.price.list === item.price.offer
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rb-sidebar-content__price",
                                          },
                                          [
                                            _c("format-price", {
                                              attrs: {
                                                value: Number(
                                                  _vm.getPriceFromItem(item)
                                                ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.price &&
                                    item.price.list !== item.price.offer
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rb-sidebar-content__price",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rb-pdp-sticky-bar__price__original",
                                              },
                                              [
                                                _c("format-price", {
                                                  attrs: {
                                                    value: Number(
                                                      item.price.list
                                                    ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rb-pdp-sticky-bar__price__discounted",
                                              },
                                              [
                                                _c("format-price", {
                                                  attrs: {
                                                    value: Number(
                                                      item.price.offer
                                                    ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : [
                                    item.discountPrice &&
                                    item.discountPrice !== item.price
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rb-sidebar-content__price",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rb-pdp-sticky-bar__price__original",
                                              },
                                              [
                                                _c("format-price", {
                                                  attrs: {
                                                    value: Number(item.price),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rb-pdp-sticky-bar__price__discounted",
                                              },
                                              [
                                                _c("format-price", {
                                                  attrs: {
                                                    value: Number(
                                                      item.discountPrice
                                                    ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rb-sidebar-content__price",
                                          },
                                          [
                                            _c("format-price", {
                                              attrs: {
                                                value: Number(item.price),
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                  ],
                              _vm._v(" "),
                              item.addToBagFlag
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "rb-btn rb-btn--red rb-sidebar-content__btn",
                                      attrs: {
                                        "data-element-id":
                                          "X_X_WishListOverlay_AddCart",
                                        "data-description":
                                          item.name + "_" + item.partnumber,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addToBag(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translation(
                                              "common.sidebar_miniwishlist_addto_bag"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ]
                    )
                  }),
            ],
            2
          ),
      _vm._v(" "),
      !_vm.isEmpty
        ? _c(
            "div",
            { staticClass: "rb-sidebar-content__bottom-section" },
            [
              _vm.isCompareButtonEnabled
                ? [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.translation(
                            "common.sidebar_miniwishlist_hardto_decide"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "rb-btn rb-sidebar-content__button-compare",
                        attrs: { href: _vm.compareWhislistView },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.translation(
                                "common.sidebar_miniwishlist_compare"
                              )
                            ) +
                            "\n      "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "rb-sidebar-content__spacer" }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "rb-sidebar-content__bottom-section__share-wishlist",
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.translation(
                          "common.sidebar_miniwishlist_share_wishlist"
                        )
                      ) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "rb-sidebar-content__social" },
                [
                  _vm.isCurrentStoreChina
                    ? [
                        _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: _vm.weiboSocialWhislist,
                              },
                            },
                            [_c("rb-lazy-icon", { attrs: { icon: "weibo" } })],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: _vm.doubanSocialWhislist,
                              },
                            },
                            [_c("rb-lazy-icon", { attrs: { icon: "douban" } })],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: _vm.youkuSocialWhislist,
                              },
                            },
                            [_c("rb-lazy-icon", { attrs: { icon: "youku" } })],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: _vm.weChatSocialWhislist,
                              },
                            },
                            [
                              _c("rb-lazy-icon", {
                                attrs: { icon: "we-chat" },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    : [
                        _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: _vm.twitterSocialWhislist,
                              },
                            },
                            [
                              _c("rb-lazy-icon", {
                                attrs: { icon: "twitter-dark" },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: _vm.pinterestSocialWhislist,
                              },
                            },
                            [
                              _c("rb-lazy-icon", {
                                attrs: { icon: "pinterest" },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: _vm.facebookSocialWhislist,
                              },
                            },
                            [
                              _c("rb-lazy-icon", {
                                attrs: { icon: "facebook-dark" },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                ],
                2
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }